// Module
var code = `  <div class="alert">
    <span>
      This form can be used to update maturity date of a loan.
      <strong>DISCLAIMER:</strong> This will NOT recalculate penalties, recalculate statuses, support accretion, and recalculate loan EIR.
      For backdated reports, the new maturity date will be used.
    </span>
  </div>

  <div ng-if="\$ctrl.loan && \$ctrl.loan.discountChargesLedger" class="alert alert--danger">
    {{\$ctrl.recreateDiscountChargesLedgerMessage}}
  </div>

  <form name="form">

    <table class="table">
      <thead>
      <tr>
        <th>Search for a loan first.</th>
        <th></th>
      </tr>
      </thead>

      <tbody>
      <tr>
        <td>Product number:</td>
        <td>
          <input
            ng-model="\$ctrl.searchProductNumber"
            type="text"
            autocomplete="off"
            required>
        </td>
        <td>
          <button type="button"
                  class="btn btn-success"
                  ng-disabled="!(\$ctrl.searchProductNumber.length > 0)"
                  ng-click="\$ctrl.searchProduct()">
            Search
          </button>
        </td>
      </tr>
      <tr ng-if="\$ctrl.loan">
        <td>Grant date:</td>
        <td>
          <date ng-disabled="true"
                output-format="date"
                ng-model="\$ctrl.loan.grantDate">
          </date>
        </td>
        <td></td>
      </tr>
      <tr ng-if="\$ctrl.loan">
        <td>Current maturity date:</td>
        <td>
          <date ng-disabled="true"
                output-format="date"
                ng-model="\$ctrl.loan.maturityDate">
          </date>
        </td>
        <td></td>
      </tr>
      <tr ng-if="\$ctrl.loan">
        <td>New maturity date:</td>
        <td>
          <date ng-required="true"
                output-format="date"
                min="\$ctrl.minDate"
                ng-model="\$ctrl.maturityDate">
          </date>
        </td>
        <td></td>
      </tr>
      <tr ng-if="\$ctrl.loan">
        <td>Term:</td>
        <td>
          <input ng-model="\$ctrl.term"
                 type="number"
                 disabled>
        </td>
        <td></td>
      </tr>
      </tbody>

    </table>

    <div class="summary-actions">
      <button type="button"
              ng-disabled="form.\$invalid"
              class="btn btn-primary"
              ng-click="\$ctrl.updateMaturityDate()">
        Update
      </button>
    </div>
  </form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/update-loan-maturity-date/update-loan-maturity-date.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;